var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout_nav"},[_c('div',{staticClass:"page_width nav tw-flex tw-items-end"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }